import {
  algoliaProductIndex,
  algoliaProductsIndexNewest,
  algoliaProductsIndexOldest,
} from 'algolia/algolia'

import {
  mapCategoryPageTypeToCategoryDetails,
  STOCKPHOTOS_AUTHOR_ID,
} from '@web/components/content-api/config'

export enum SearchableFilters {
  PROMO = 'hasPromotions',
  CATEGORY = 'category',
  TYPE = 'type',
  HAS_POD = 'hasPod',
}

export const SORTING_OPTIONS = [
  { value: algoliaProductIndex, label: 'sorting.sort_most_relevant', type: 'popular' },
  { value: algoliaProductsIndexNewest, label: 'sorting.sort_newest_first', type: 'newest' },
  { value: algoliaProductsIndexOldest, label: 'sorting.sort_oldest_first', type: 'oldest' },
]

export const ALLOWED_CONTENT_PRODUCTS_AUTHOR_IDS = [
  ...Object.values(mapCategoryPageTypeToCategoryDetails).map(category => category.authorId),
  STOCKPHOTOS_AUTHOR_ID,
]

export const EXCLUDED_PRODUCTS_CATEGORIES_WHEN_AI_CONTENT_IS_DISABLED = [
  '"AI Illustrations"',
  '"AI Graphics"',
  '"AI Transparent PNGs"',
  '"AI Generated"',
  '"AI Patterns"',
  '"AI Coloring Pages"',
  '"AI Sketches"',
]
